import React, { useEffect, useState } from "react";
import MainScreen from "../../components/Navbar/MainScreen";
import axios from "axios";
import AXIOS from "../../utils/AXIOS";
import { connect } from "react-redux";

import {
  Box,
  Card,
  CircularProgress,
  Tooltip,
  Typography,
} from "@mui/material";
import "./ViewCampaign.css";
import { useNavigate } from "react-router-dom";
import {
  campaignStatus,
  encodeData,
  formatDateToDDMMYYYY,
} from "../../utils/Constants";
import Lottie from "react-lottie-player";
import loadingAnime from "../../assets/lottieFiles/loader.json";
import NoDataFoundAnime from "../../assets/lottieFiles/noData.json";
import { FaArrowLeftLong } from "react-icons/fa6";
import { IconContext } from "react-icons";
import toast from "react-hot-toast";
import CustomDropdown from "../../components/CustomDropDown/CustomDropDown";
import CustomInput from "../../components/CustomInput/CustomInput";

function ViewCampaigns(props) {
  const navigate = useNavigate();
  const [transactionFlags, setTransactionFlags] = useState({
    TBODY_LOADING: true,
    TBODY_EMPTY: false,
  });

  const [searchQuery, setSearchQuery] = useState({
    SEARCH_KEY: { label: "Campaign Name", value: "CAMPAIGN_NAME" },
    SEARCH_VALUE: "",
    SEARCH_LOADING: false,
  });

  const searchKeyOptions = [
    { label: "Campaign Name", value: "CAMPAIGN_NAME" },
    { label: "Campaign Subject", value: "CAMPAIGN_SUBJECT" },
    // { label: "Recipient Email", value: "RECIPIENT_EMAIL" },
    { label: "Sent Date", value: "CAMPAIGN_COMPLETE_TIME" },
    { label: "Created Date", value: "CREATED_TIME" },
    { label: "Created By", value: "CREATED_BY_NAME" },
  ];

  useEffect(() => {}, [searchQuery]);
  useEffect(() => {
    if (props.auth_id) {
      getCampaigns();
    }
  }, [props.auth_id]);

  const [Tbody, setTbody] = useState([]);
  const [TbodyCopy, setTbodyCopy] = useState([]);
  const getCampaigns = () => {
    axios
      .post(AXIOS.defaultPort + AXIOS.getCampaign, {
        auth_id: props.auth_id,
      })
      .then((response) => {
        let tempTransactionFlags = { ...transactionFlags };
        tempTransactionFlags.TBODY_LOADING = false;
        if (response.data.length > 0) {
          setTbody(response.data);
          setTbodyCopy(response.data);
        } else {
          tempTransactionFlags.TBODY_EMPTY = true;
        }
        setTransactionFlags(tempTransactionFlags);
      })
      .catch((err) => {
        setTransactionFlags((prev) => ({
          ...prev,
          TBODY_DATA_FOUND: false,
        }));
        toast.error("Something went wrong");
      });
  };

  const handleCampaignSearch = () => {
    const filteredData = TbodyCopy.filter((user) => {
      const searchKey = searchQuery.SEARCH_KEY.value; // Extract the search key
      const userValue = user[searchKey]?.toString().toLowerCase(); // Convert to string safely
      const searchValue = searchQuery.SEARCH_VALUE?.toLowerCase(); // Convert search query to lowercase

      return userValue && userValue.includes(searchValue);
    });
    setSearchQuery((prev) => ({
      ...prev,
      SEARCH_LOADING: false,
    }));
    setTbody(filteredData);
  };

  const dateFields = ["CAMPAIGN_COMPLETE_TIME", "CREATED_TIME"];
  const nonDateFields = [
    "CAMPAIGN_NAME",
    "CAMPAIGN_SUBJECT",
    "CREATED_BY_NAME",
  ];
  const today = new Date().toISOString().split("T")[0];
  const handleSearchKeyChange = (e) => {
    setSearchQuery((prev) => {
      const isPrevDateField = dateFields.includes(prev.SEARCH_KEY?.value);
      const isNewDateField = dateFields.includes(e.value);

      if (isNewDateField) {
        // If switching to a date field, reset or preserve the date if valid
        return {
          ...prev,
          SEARCH_KEY: e,
          SEARCH_VALUE:
            isPrevDateField && prev.SEARCH_VALUE ? prev.SEARCH_VALUE : today,
        };
      }

      if (!isNewDateField && isPrevDateField) {
        // If switching from a date field to a non-date field, reset SEARCH_VALUE
        return {
          ...prev,
          SEARCH_KEY: e,
          SEARCH_VALUE: "",
        };
      }

      // If switching between non-date fields, keep SEARCH_VALUE as it is
      return { ...prev, SEARCH_KEY: e };
    });
  };

  return (
    <MainScreen>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingTop: 3,
          paddingBottom: 1,
          paddingLeft: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              mr: 1,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            <IconContext.Provider value={{ size: 25, color: "#000" }}>
              <FaArrowLeftLong />
            </IconContext.Provider>
          </Box>
          {/* <h9 className="header-text">Contact Capture</h9> */}
          <Typography
            style={{
              fontSize: 22,
              fontWeight: 600,
              color: "#000",
              marginRight: 10,
              textAlign: "start",
            }}
          >
            View Campaigns
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: 2,
            gap: 1,
          }}
        >
          <Box
            sx={{
              // mr: 1,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              // navigate(-1);
            }}
          >
            <div
              style={{
                width: 180,
              }}
            >
              <CustomDropdown
                Options={searchKeyOptions}
                isSearchable={false}
                Value={searchQuery.SEARCH_KEY}
                OnChange={(e) => {
                  handleSearchKeyChange(e);
                }}
              />
            </div>
          </Box>
          {/* <h9 className="header-text">Contact Capture</h9> */}
          <CustomInput
            Placeholder={"Search"}
            Value={searchQuery.SEARCH_VALUE}
            Type={
              searchQuery.SEARCH_KEY.value == "CAMPAIGN_COMPLETE_TIME" ||
              searchQuery.SEARCH_KEY.value == "CREATED_TIME"
                ? "date"
                : "text"
            }
            onChange={(e) => {
              setSearchQuery((prev) => ({
                ...prev,
                SEARCH_VALUE: e.target.value,
              }));
            }}
          />
          <button
            className="status running"
            style={{
              cursor: "pointer",
              minWidth: 70,
              justifyContent: "center",
              minHeight: 30,
            }}
            onClick={() => {
              setSearchQuery((prev) => ({
                ...prev,
                SEARCH_LOADING: true,
              }));
              handleCampaignSearch();
            }}
          >
            {searchQuery.SEARCH_LOADING == true ? (
              <CircularProgress size={"20px"} color="success" />
            ) : (
              "Search"
            )}
          </button>
          <button
            className="status running"
            style={{
              cursor: "pointer",
              minWidth: 70,
              justifyContent: "center",
              minHeight: 30,
              color: "red",
              borderColor: "red",
            }}
            onClick={() => {
              setSearchQuery((prev) => ({
                ...prev,
                SEARCH_VALUE: "",
                SEARCH_LOADING: false,
              }));
              setTbody(TbodyCopy);
            }}
          >
            Reset
          </button>
        </Box>
      </Box>
      {transactionFlags.TBODY_LOADING == true && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "70vh",
          }}
        >
          <Lottie
            style={{
              width: 250,
              height: 250,
            }}
            play
            //   speed={"1"}
            animationData={loadingAnime}
          />
        </Box>
      )}
      {transactionFlags.TBODY_LOADING == false && Tbody.length <= 0 == true && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            minHeight: "70vh",
            alignItems: "center",
          }}
        >
          <div>
            <Lottie
              style={{
                width: 350,
                height: 350,
              }}
              play
              animationData={NoDataFoundAnime}
            />
            <p
              style={{
                textAlign: "center",
              }}
              className="recipient-description"
            >
              No Data Found
            </p>
          </div>
        </Box>
      )}

      {props.components_list.includes("view-campaigns") && (
        <Box className="campaign-card-grid-container">
          {Tbody.map((val) => {
            let campaignNameMaxLength = 58;
            const isCampaignNameLongText =
              val?.CAMPAIGN_NAME &&
              val.CAMPAIGN_NAME.length > campaignNameMaxLength;
            const campaignNameDisplayText = isCampaignNameLongText
              ? val?.CAMPAIGN_NAME?.substring(0, campaignNameMaxLength) + "..."
              : val?.CAMPAIGN_NAME || "";
            return (
              <div
                className="campaign-card"
                onClick={() => {
                  navigate(
                    "/campaign-details?CAMPAIGN_ID=" + encodeData(val._id),
                    {
                      state: {
                        campaign_id: val._id,
                      },
                    }
                  );
                }}
              >
                <div className="header">
                  <div className="left-section">
                    <div className="left-section-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#FFFFFF"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <circle cx="9" cy="21" r="1"></circle>
                        <circle cx="20" cy="21" r="1"></circle>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                      </svg>
                    </div>
                    <div className="details">
                      <Tooltip
                        arrow
                        title={
                          isCampaignNameLongText ? val?.CAMPAIGN_NAME : null
                        }
                      >
                        <h3>{campaignNameDisplayText}</h3>
                      </Tooltip>

                      <p>{val.CAMPAIGN_DESCRIPTION}</p>
                    </div>
                  </div>
                  <div className="right-section">
                    {/* <span className="messages">{val.CREATED_TIME}</span> */}
                    {/* <span className="segments">04</span> */}
                    <span
                      className="status running"
                      style={{
                        borderColor: campaignStatus.find(
                          (item) => item.value == val.CAMPAIGN_STATUS
                        )?.color,
                        color: campaignStatus.find(
                          (item) => item.value == val.CAMPAIGN_STATUS
                        )?.color,
                      }}
                    >
                      <div className="dot" />{" "}
                      {campaignStatus.find(
                        (item) => item.value == val.CAMPAIGN_STATUS
                      )?.label || ""}
                      {campaignStatus.find(
                        (item) => item.value == val.CAMPAIGN_STATUS
                      )?.icon || ""}
                    </span>
                    {/* <button className="menu-button">...</button> */}
                  </div>
                </div>

                {/* Tags */}
                <div className="tags">
                  <span className="tag">
                    {/* {val.CREATED_TIME} */} Created On :{" "}
                    <span>
                      {val.CREATED_TIME
                        ? formatDateToDDMMYYYY(val.CREATED_TIME)
                        : ""}{" "}
                    </span>
                    <span
                      style={{
                        marginLeft: 5,
                      }}
                    >
                      {val.CREATED_TIME
                        ? new Date(val.CREATED_TIME).toLocaleString("en-US", {
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                            hour12: true,
                          })
                        : "--"}
                    </span>
                  </span>
                  <span className="tag">Created By: {val.CREATED_BY_NAME}</span>
                </div>

                {/* Stats */}
                <div className="bottom-stats">
                  <div className="stats">
                    <div className="stat">
                      <h4>
                        {val.RECIPIENT_COUNT != null
                          ? val.RECIPIENT_COUNT
                          : "--"}
                      </h4>
                      <p>
                        Total Recipient <br />
                      </p>
                    </div>
                    <div className="stat">
                      <h4>
                        {val.DELIVERED_COUNT != null
                          ? val.DELIVERED_COUNT
                          : "--"}
                      </h4>
                      <p>
                        Total Delivered <br />
                      </p>
                    </div>
                    <div className="stat">
                      <h4>
                        {val.OPENED_COUNT != null ? val.OPENED_COUNT : "--"}
                      </h4>
                      <p>
                        Total Opened <br />
                      </p>
                    </div>
                    {/* <div className="stat">
                    <h4>{}</h4>
                    <p>
                      Clicked <br /> Last 30 Days
                    </p>
                  </div> */}
                    <div className="stat">
                      <h4>
                        {val.BOUNCED_COUNT != null ? val.BOUNCED_COUNT : "--"}
                      </h4>
                      <p>
                        Total Bounced <br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Box>
      )}
    </MainScreen>
  );
}

const mapStateToProps = (state) => ({
  auth_email_id: state.contactData.auth_email_id,
  auth_name: state.contactData.auth_name,
  auth_id: state.contactData.auth_id,
  components_list: state.contactData.components_list,
});

export default connect(mapStateToProps, {})(ViewCampaigns);
